import React from 'react'
import Card from 'react-bootstrap/Card'
import './DescriptionCard.css'

const descriptionCard = (props) => {
    return (
        <Card className={'mx-auto description-card'}>
            <Card.Body>
                <Card.Title className={'description-card-title'}>
                    {props.title}
                </Card.Title>
                {props.children}
            </Card.Body>
        </Card>
    )
};
export default descriptionCard;